const TermsAndConditionsGold = () => {
	return (
		<section className="page_container tnc">
			<h3>SALT Rewards & Digital Gold Transactions - TLDR</h3>
			<p>
				We encourage you to read detailed terms and conditions stipulated in
				this document below, but we surely recommend that you to read the
				following summary-
			</p>
			<ul>
				<li>
					Buying digital gold in place of physical gold shifts the cost of
					custody and movement of gold to your service provider, in this case,
					<a href="https://safegold.com">SafeGold</a>. Only residents of India
					can buy gold through SALT Platform.
				</li>
				<li>The gold purchased by you will be 24 karat with 99.99% purity.</li>
				<li>
					The minimum purchase and sale amount may be subject to change as
					determined by SALT at its sole discretion without prior notice
				</li>
				<li>
					The price of gold is based on live buy-sell quote provided by SafeGold
					which will be derived from the wholesale bullion market plus a
					commission to cover operating costs. You will see this reflected in
					the difference between buy price and sell price.
				</li>
				<li>
					Depending on the mode of payment you choose, convenience charges
					levied by the payment gateway (Razorpay) shall be applicable.
				</li>
				<li>In case of purchase, 3% GST shall be applicable.</li>
				<li>
					The minimum amount for sale of gold shall be determined by SALT from
					time to time.
				</li>
				<li>
					The gold purchased by you will be kept in vaults. The storage and
					vault service is provided by{" "}
					<a href="https://www.brinks.com/en/public/brinks-india">Brinks</a> and
					<a href="https://sequelglobal.com/">Sequel Logistics</a> , which have
					comprehensive, global insurance policies on the gold stored. SafeGold
					has an additional insurance policy to cover gold in transit.
				</li>
				<li>
					You have title of the gold purchased and an exclusive charge by way of
					hypothecation on your gold holding is created by{" "}
					<a href="https://www.vistra.com/">
						Vistra Corporate Services India Private Limited
					</a>
					. This charge is released only when you sell or take physical
					delivery.
				</li>
				<li>
					Your gold is not a part of the assets of SafeGold. Any unlikely
					adverse event for e.g. SafeGold going into liquidation shall not
					affect your gold holding.
				</li>
				<li>
					When you ask for delivery, the requisite gold is removed from Brinks
					and/or Sequel Logistics and delivered to you.
				</li>
				<li>
					You will be provided free storage of your gold for up to 5 years and
					thereafter you will be charged nominal storage fees as published by
					SafeGold.
				</li>
				<li>
					You can order for physical delivery of your gold (coming soon on SALT
					Platform), starting from 0.5 grams and multiples thereof. The gold
					will be delivered to you in the form of assay certified coins, in
					tamper evident packaging. Subject to the design and weight chosen,
					making charges and delivery charges will apply. SafeGold will arrange
					doorstep delivery of the gold through secured logistics providers.
				</li>
				<li>
					You can also exchange your gold holding for gold jewellery at partner
					jewellery stores - Tanishq, Caratlane and Candere by Kalyan Jewellers
					at this point (coming soon on SALT Platform).
				</li>
			</ul>
			<h4 className="text-underline">SALT Gold Rewards:</h4>
			<ul>
				<li>
					SALT has a Rewards Program to reward users who meet engagement
					thresholds which may be specified by SALT from time to time. By
					meeting engagement thresholds, you may be entitled to gold rewards.
					The amount of gold rewards which can be redeemed by you by
					participating in the Rewards program shall be specified by SALT and
					are modifiable by SALT without prior notice.
				</li>
				<li>
					For any active offers on Digital Gold, please refer to the{" "}
					<a href="https://my.salt.one/gbdaytnc">T&Cs here</a>
				</li>
			</ul>
			<h3 className="c0">
				SALT Rewards &amp; Digital Gold Transactions Terms and Conditions
			</h3>

			<h4 className="c1">Last Updated: 27th September, 2022</h4>

			<h4 className="c0">Definitions</h4>

			<ol type="1" className="c7 lst-kix_list_1-0 start">
				<li className="c3 li-bullet-1">
					<span className="c5">The words &ldquo;</span>
					<b className="c8">User/ user</b>
					<span className="c5">&rdquo;, &ldquo;</span>
					<b className="c8">You/ you</b>
					<span className="c5">&rdquo; and &ldquo;</span>
					<b className="c8">Your/ your</b>
					<span className="c5">
						&rdquo; refer to the person(s) who use and avail the Services (as
						defined in Terms &amp; Conditions) of SALT through the Platform and
						shall include both singular and plural. The Services provided by
						SALT are only for Indian citizens and tax residents of India.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">&ldquo;</span>
					<b className="c0">Engagement Thresholds</b>
					<span className="c1">
						&rdquo; means the thresholds of engagement, which may be specified
						by SALT, which a user may meet to participate in the Rewards
						Program.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">&ldquo;</span>
					<b className="c0">Digital Gold</b>
					<span className="c1">
						&rdquo; means the gold which may be purchased digitally using the
						Platform in partnership with SafeGold.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">&ldquo;</span>
					<b className="c0">Gold Rewards</b>
					<span className="c1">
						&rdquo; means the Digital Gold which may be redeemed by users by
						participating in the Rewards Program.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">&ldquo;</span>
					<b className="c0">Rewards Program</b>
					<span className="c1">
						&rdquo; means the customer loyalty program which may be offered by
						SALT to reward users who meet the Engagement Thresholds on a
						recurring basis.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">&ldquo;</span>
					<b className="c0">SALT</b>
					<span className="c1">
						&rdquo; means Five Salts Private Limited, a private limited company
						incorporated under the Companies Act, 2013.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">The Websites </span>
					<span className="c4">
						<a className="c11" href="https://www.salt.one">
							www.salt.one
						</a>
					</span>
					<span className="c1">&nbsp;</span>
					<span className="c5">and </span>
					<span className="c4">
						<a className="c11" href="https://app.salt.one">
							app.salt.one
						</a>
					</span>
					<span className="c5">
						, their sub-domains and other sites/ apps/ other channels maintained
						by SALT to provide Services (as defined in Terms &amp; Conditions)
						&nbsp;shall be referred to as the &ldquo;Platform&rdquo;
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">&ldquo;</span>
					<b className="c0">SALT Gold Account</b>
					<span className="c1">
						&rdquo; means a user&rsquo;s Account on the Platform which has been
						linked to SafeGold.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">&ldquo;</span>
					<b className="c0">SafeGold</b>
					<span className="c1">
						&rdquo; means Digital Gold India Private Limited.
					</span>
				</li>
				<li className="c6 li-bullet-1">
					<span className="c1">&ldquo;</span>
					<b className="c0">SafeGold Account</b>
					<span className="c1">
						&rdquo; means the account which may be created by a user with
						SafeGold for the purchase of Digital Gold.
					</span>
				</li>
			</ol>

			<h4 className="c0">Eligibility</h4>

			<ol type="1" className="c7 lst-kix_list_14-0 start">
				<li className="c3 li-bullet-2">
					<span className="c1">
						Users located outside India shall not be eligible to participate in
						the Rewards Program, and purchase/ sale of Digital Gold on the
						Platform.
					</span>
				</li>
				<li className="c6 li-bullet-1">
					<span className="c1">
						Only one account per user will be recognized as eligible for the
						Rewards Program and purchase/ sale of Digital Gold on the Platform.
					</span>
				</li>
			</ol>

			<h4 className="c0">SALT Rewards Terms and Conditions</h4>

			<ol type="1" className="c7 lst-kix_list_2-0 start">
				<li className="c3 li-bullet-1">
					<span className="c1">
						The structure and duration of the&nbsp;Rewards Program, as well as
						the selection of users it is rolled out to, are at the sole
						discretion of SALT and shall be modifiable by SALT without prior
						notice.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						The Engagement Thresholds may be specified by SALT at its sole
						discretion, and shall be modifiable by SALT without prior notice.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">
						By meeting the Engagement Thresholds, a user may be entitled to Gold
						Rewards. The amount of Gold Rewards redeemable by a user by
						participating in the Rewards Program may be specified by SALT at is
						sole discretion, and shall be modifiable by SALT without prior
						notice.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						SALT reserves the right to disqualify any user from receiving Gold
						Rewards or cancelling any Gold Rewards already credited in case (
					</span>
					<b className="c0">a</b>
					<span className="c1">
						) the user does not meet the requirements of the Rewards Program; or
						(
					</span>
					<b className="c0">b</b>
					<span className="c1">
						) in case of reasons including but not limited to any misuse of the
						Rewards Program or fraud or suspicious transaction/activity or under
						any legal requirement or applicable rules and regulations.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						In case of a dispute, the final decision to credit/modify the Gold
						Rewards shall lie with SALT.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						Redemption of Gold Rewards is voluntary, and all related charges
						shall be deemed to be voluntarily incurred by a user.
					</span>
				</li>
				<li className="c6 li-bullet-1">
					<span className="c1">
						You agree to not hold SALT responsible for any actions, claims,
						demands, liabilities, losses, damages, costs, charges or expenses,
						which you may incur, in the normal course of participating in the
						Rewards Program.
					</span>
				</li>
				<li>
					SALT shall have the right to ask for KYC information as required under
					applicable laws.
				</li>
			</ol>

			<h4 className="c0">Digital Gold Terms and Conditions</h4>

			<ol type="1" className="c7 lst-kix_list_11-0 start">
				<li className="c2 li-bullet-2">
					<span className="c1">
						You may avail the option of purchasing and/or selling Digital Gold
						through the Platform.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">
						Notwithstanding anything contained in the Terms &amp; Conditions and
						this Addendum A, SALT reserves the right to withdraw the facility to
						purchase and/or sell Digital Gold on the Platform at any time, at
						its sole discretion.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c5">
						By opening a SALT Gold Account on the Platform, you expressly
						authorize SALT to access, use and store transaction information and
						other information related to your SALT Gold Account on an ongoing
						basis for the purpose of providing you with services relating to
						Digital Gold.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						It is clarified that SALT is merely providing a platform to
						facilitate the purchase and sale of Digital Gold through SafeGold,
						and will not be liable in any manner with respect to the products
						and/or services offered to you by SafeGold.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						By utilising the Platform to purchase and/or sell Digital Gold, you
						shall be bound by the{" "}
					</span>
					<span className="c4">
						<a className="c11" href="/sfg-tnc.html">
							Terms and Conditions of SafeGold
						</a>
					</span>
					<span className="c1">.</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">
						The payment for Digital Gold purchase/ sale shall be facilitated
						through a third-party payment gateway (&quot;Payment
						Gateway&rdquo;),with whom SALT has entered into an arrangement. The
						account information entered by the user at the time of purchase
						shall be stored in the Payment Gateway. The account information
						entered by the user in case of sale of Digital Gold shall also be
						stored in the Payment Gateway. In case of payment failure during
						purchase of Digital Gold, any amount debited shall be automatically
						refunded to the payment method that the user used to make the
						payment. The refund shall be processed through the Payment Gateway,
						and SALT shall not be liable for the same. In case of sale of
						Digital Gold, the remittance of sale proceeds to your account shall
						be processed through the Payment Gateway and SALT shall not be
						liable for the same.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">
						The purchase / sale of Digital Gold may involve GST which is charged
						by SafeGold as per applicable laws, and the user may have to incur
						additional convenience fees based on the payment method, which are
						levied by the Payment Gateway.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c5">
						SALT may display such information on the Platform, from time to
						time, as may be provided and updated by SafeGold for general
						information purposes. SALT shall neither be liable nor be
						responsible for the accuracy of such information which is provided
						by SafeGold.{" "}
					</span>
					<span className="c1">
						You agree and acknowledge that the data and information provided on
						the Platform does not constitute advice of any nature whatsoever and
						shall not be relied upon by you while making purchase and/or sale of
						Digital Gold; and you shall be solely responsible for any purchase
						and/or sale of Digital Gold.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c1">
						The price displayed on the Platform, represents the market linked
						price of gold as indicated by SafeGold. Market linked prices means
						that these quotes are linked to the prices of gold in the commercial
						bullion market in India.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						Notwithstanding the foregoing, you understand that these prices may
						vary multiple times within a day, and accordingly your payment
						obligations for any order will depend on the market linked prices
						then prevailing. While reasonable efforts will be made by SafeGold
						to offer you a competitive price for the Digital Gold, there is no
						guarantee that the price offered to you will be close to or
						comparable with other prices available in the market.
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						The minimum and maximum amount eligible for the purchase and/or sale
						of Digital Gold shall be determined by SALT at its sole discretion.
						The decision of SALT with respect to these thresholds shall
						supersede the thresholds specified in the{" "}
					</span>
					<span className="c4">
						<a className="c11" href="/sfg-tnc.html">
							Terms and Conditions of SafeGold
						</a>
					</span>
					<span className="c1">.</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c1">
						You acknowledge that the Gold Rewards/Digital Gold transactions on
						the Platform are for your personal use and agree not to publish the
						prices of gold, descriptions of gold and/or any other information
						displayed on the Platform (by virtue of your access to the Platform)
						on any other medium. You agree to use the Platform only: (
					</span>
					<b className="c0">a</b>
					<span className="c1">
						) for purposes that are permitted by the Terms &amp; Conditions and
						this Addendum A; and (
					</span>
					<b className="c0">b</b>
					<span className="c1">
						) in accordance with any applicable law, regulation or generally
						accepted practices or guidelines
					</span>
				</li>
				<li className="c2 li-bullet-2">
					<span className="c5">
						SALT reserves the right, in its sole and absolute discretion, to (
					</span>
					<b className="c8">a</b>
					<span className="c5">
						) suspend access to a user&rsquo;s SALT Gold Account; or (
					</span>
					<b className="c8">b</b>
					<span className="c5">
						) request SafeGold to terminate a user&rsquo;s SafeGold Account,
						without notice and without liability to the user or any third party,
						for any reason, including submission of incorrect account details,
						fraud, violation of the{" "}
					</span>
					<span className="c1">
						Terms &amp; Conditions and/or this Addendum A,
					</span>
					<span className="c5">
						&nbsp;or other policies SALT may establish from time to time. In
						such event, SALT may take any action it deems necessary including,
						but not limited to, crediting the user&rsquo;s bank account and/or
						having SafeGold repurchase the Digital Gold held in the user&rsquo;s
						SafeGold Account.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c5">
						All payment transactions initiated using a SALT Gold Account shall
						be subject to the Terms & Conditions and this Addendum A. For
						avoidance of doubt, SALT will provide the technology integration of
						a user&rdquo;s SafeGold Account with the user&rdquo;s SALT Gold
						Account on the Platform. However, all transactions relating to
						Digital Gold are conducted between the user and SafeGold only. SALT
						shall neither be responsible nor liable for any losses arising out
						of or in relation to any transaction relating to the purchase of
						Digital Gold.
					</span>
				</li>
				<li className="c2 li-bullet-1">
					<span className="c10">You can reach out to SALT at </span>
					<span className="c4">
						<a className="c11" href="mailto:support@salt.one">
							support@salt.one
						</a>
					</span>
					<span className="c10">
						&nbsp;to raise any questions, complaints, grievances or provide
						feedback
					</span>
				</li>
			</ol>
			<p className="c20 c21">
				<span className="c1"></span>
			</p>
			<p className="c20">
				<a
					href="https://resources.salt.one/gold/SafeGold_FAQs.pdf"
					target={"_blank"}
					className="c16"
					rel="noreferrer"
				>
					Click here to read the FAQs of SafeGold
				</a>
			</p>
			<p className="c9">
				<span className="c12">
					<a className="c11" href="/sfg-tnc.html">
						Click here to read the Terms and Conditions of SafeGold
					</a>
				</span>
			</p>
			<style jsx>{`
			:global(html, body) {
        overflow: initial;
      }
      h3 {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: var(--primary-400);
        margin: var(--sp-02) 0px;
      }
      h3 {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: var(--primary-400);
        margin: var(--spx-01) 0px;
      }
      h4 {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        text-align: left;
        color: var(--primary-400);
        margin: var(--spx-01) 0px;
      }
      b{
        color: var(--primary-400);
      }
      i{
        var(--primary-300);
      }
      p,
      ol, ul,
      li {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: var(--primary-400);
      }
      a {
        text-decoration: revert;
        color: revert;
      }
      section {
        padding: var(--sp-03);
      }
			`}</style>
		</section>
	);
};

export default TermsAndConditionsGold;
